/**
 * AuthContext — v2.0.7
 * 
 * Compatibility wrapper: re-exports useUnifiedAuth as useAuth.
 * All components that use useAuth() will automatically get
 * auth data from the PostMessage auto-provision flow.
 */
import { useUnifiedAuth } from './UnifiedAuthContext';

// Re-exportar o hook com nome antigo para compatibilidade
export const useAuth = useUnifiedAuth;